import { adalApiFetch } from "../auth/adalConfig"
import { getOptionsWithCorrelationContext } from "../helper/constants"

const getHearingInstruments = async (
  pageSize,
  pageNumber,
  correlationContext = ""
) => {
  let options = {
    method: "get",
    headers: {
      "Content-Type": "application/ json",
    },
  }

  options = getOptionsWithCorrelationContext(options, correlationContext)

  return adalApiFetch(
    fetch,
    `/api/hearing-instruments?pageSize=${pageSize}&pageNumber=${pageNumber}`,
    options
  )
    .then(async (response) => {
      if (response.status === 200) {
        let json = await response.json()
        return { data: json, statusCode: 200 }
      }
      return { statusCode: response.status }
    })
    .catch((err) => {
      console.log(err)
    })
}

const getHearingInstrumentsWithSearch = async (
  pageSize,
  pageNumber,
  searchColumn,
  searchValue,
  correlationContext = ""
) => {let options = {
    method: "get",
    headers: {
      "Content-Type": "application/ json",
    },
  }

  options = getOptionsWithCorrelationContext(options, correlationContext)

  return adalApiFetch(
    fetch,
    `/api/hearing-instruments/search?pageSize=${pageSize}&pageNumber=${pageNumber}&searchColumn=${searchColumn}&searchValue=${searchValue}`,
    options
  )
    .then(async (response) => {
      if (response.status === 200) {
        let json = await response.json()
        return { data: json, statusCode: 200 }
      }
      return { statusCode: response.status }
    })
    .catch((err) => {
      console.log(err)
    })
}

const getOneHearingInstrument = async (id, correlationContext = "") => {
  let options = {
    method: "get",
    headers: {
      "Content-Type": "application/ json",
    },
  }

  options = getOptionsWithCorrelationContext(options, correlationContext)

  return adalApiFetch(
    fetch,
    `/api/hearing-instruments/search?pageSize=1&pageNumber=1&searchColumn=id&searchValue=${id}`,
    options
  )
    .then(async (response) => {
      if (response.status === 200) {
        let json = await response.json()
        return { data: json, statusCode: 200 }
      }
      return { statusCode: response.status }
    })
    .catch((err) => {
      console.log(err)
    })
}

export { getHearingInstruments, getOneHearingInstrument, getHearingInstrumentsWithSearch }
